/* import __COLOCATED_TEMPLATE__ from './add-account-help.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();